import {spac} from 'constants/url';
import useLoad from '../../../components/hooks/useLoad';

function useLoadSpac(additional: string | undefined = undefined) {
  return useLoad(spac, 'iD_Spac', {additional});
}

export default useLoadSpac;
